import { SimpleGrid } from '@chakra-ui/react';

import CustomFieldBuilder from 'components/CustomFieldBuilder';
import { ICustomFieldItem } from 'hooks/customField/useFetchPaginatedCustomFields';

const TimesheetCustomField = ({
  customFieldsData,
  isChildTimesheet,
}: {
  customFieldsData: Array<ICustomFieldItem>;
  isChildTimesheet: boolean;
}) => {
  return (
    <SimpleGrid columns={2} spacing="4">
      {Array.isArray(customFieldsData) && customFieldsData.length
        ? customFieldsData.map(customField => {
            return (
              <div key={customField.id}>
                <CustomFieldBuilder
                  customField={customField as ICustomFieldItem}
                  shouldValidateField={!isChildTimesheet}
                />
              </div>
            );
          })
        : null}
    </SimpleGrid>
  );
};

export default TimesheetCustomField;
